export default __webpack_public_path__ + "static/media/InstaIcon.efbc8b6a.PNG";